import Input from './input';

import { FormEvents, FormEventHandler } from '../../events/form_event_handler';
import { FormAPI } from 'lecom-api';

export default class InputEventsPublisher extends Input {
	getInputComponentEventListeners() {
		const eventListeners = {
			onFocus: this.handleFocus.bind(this),
			onBlur: this.handleBlur.bind(this),
			onChange: this.handleChange.bind(this),
			onClick: this.handleClick.bind(this)
		};

		switch (this.getInputComponent()) {
			case "autocomplete":
			case "radio":
				return Object.assign({}, eventListeners, {
					onLoad: this.handleAutocompleteLoad.bind(this),
					onLoadError: this.handleAutocompleteLoadError.bind(this)
				});
			case "checkbox":
				return Object.assign({}, eventListeners, { onCheck: this.handleChecked.bind(this) });
			default:
				return eventListeners;
		}
	}

	handleFocus(event) {
		this.props.onFocus(event);
		this.publishEvent(FormEvents.FOCUS);
	}

	handleBlur(event) {
		this.props.onBlur(event);
		this.publishEvent(FormEvents.BLUR);
	}

	handleChange(event, value) {
		const fieldAPI = this.getFieldAPI();

		if (!!this.props.onChange(event, value) &&
			String(fieldAPI.value()) !== String(value) &&
			(typeof value !== 'number' || !isNaN(value))) {

			if (this.getInputComponent() === "autocomplete" && !Array.isArray(value)) {
				value = [value];
			}

			if(this.getInputComponent() === 'autocomplete'){
				this.getFieldAPI().set({value});
				setTimeout(()=>this.publishEvent(FormEvents.CHANGE, value), 0);
				// this.publishEvent(FormEvents.BLUR, value);
				// this.publishEvent(FormEvents.FOCUS, value);
				this.publishEvent(FormEvents.KEY_PRESS, value);
			}

			if (this.getInputComponent() === "checkbox") {
				setTimeout(()=>this.publishEvent(FormEvents.CHANGE, value), 0);
			}

			if(this.getInputComponent() === "radio"){
				this.getFieldAPI().set({value});
				setTimeout(()=>this.publishEvent(FormEvents.CHANGE, value), 0);
				// this.publishEvent(FormEvents.BLUR, value);
				// this.publishEvent(FormEvents.FOCUS, value);
				this.publishEvent(FormEvents.KEY_PRESS, value);
			}

			if(this.getInputComponent() === 'datepicker'){
				this.getFieldAPI().set({value});
				setTimeout(()=>this.publishEvent(FormEvents.CHANGE, value), 0);
				setTimeout(()=>this.publishEvent(FormEvents.KEY_PRESS, value),0);
				// this.publishEvent(FormEvents.BLUR, value);
				this.publishEvent(FormEvents.FOCUS, value)
			}

			else {
				this.getFieldAPI().set({value});
				setTimeout(()=>this.publishEvent(FormEvents.KEY_PRESS, value),0);
			}
		}


	}

	handleChecked(checked, value, isPublishEvents=true) {
		const fieldAPI = this.getFieldAPI();
		fieldAPI.set({ checked, value });

		if (isPublishEvents) {
			setTimeout(()=>this.publishEvent(FormEvents.CHANGE, value), 0);
			// this.publishEvent(FormEvents.FOCUS, value);
			// this.publishEvent(FormEvents.BLUR, value);
			this.publishEvent(FormEvents.KEY_PRESS, value);
		}
	}

	handleClick(event) {
		this.props.onClick(event);
		this.publishEvent(FormEvents.CLICK);
	}

	handleAutocompleteLoad(data) {
		this.publishEvent(FormEvents.AUTOCOMPLETE_DATA_LOAD_SUCCESS, data);
		this.getFieldAPI().set({ options: data }).apply();
	}

	handleAutocompleteLoadError(xhr, status, error) {
		this.publishEvent(FormEvents.AUTOCOMPLETE_DATA_LOAD_ERROR, status, error);
	}

	getFieldAPI() {
		if (this.props.formId) {
			const formAPI = FormAPI.form(this.props.formId);
			return (this.props.gridFormParent)
			? formAPI.fields(this.props.gridFormParent).fields(this.props.id)
			: formAPI.fields(this.props.id);
		}
		return null;
	}

	publishEvent(eventName, ...args) {
		const field = this.getFieldAPI();
		if (field)
			field.publish(eventName, ...args);
	}
}
